import React, { Fragment } from 'react'

import { Tooltip as TooltipBase } from "@strapi/design-system/Tooltip";

const Tooltip = ({
  className,
  visible = true,
  children,
  delay,
  description,
  id,
  label,
  position = 'bottom',
}) => {
  const props = {
    className,
    delay,  
    description,
    id,
    label,
    position,
    children,
  }

  if (!visible) {
    return (
      <Fragment>
        {children}
      </Fragment>
    )
  }
  
  return <TooltipBase {...props} />
}

export default Tooltip
